// Global rollout / feature flags
// Toggle features here to control rollout across the app.

export const rollout = {
  // Controls:
  // - Following tab on deals page
  // - Follow button in deal details
  enableFollowing: true,
};


